import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { ls } from "../../../../strings.js";
import { Button } from "../../../button.js";
import { ConnectionFailed as PasskeyConnectionFailed } from "../../../../icons/connectionFailed.js";
import { Timeout } from "../../../../icons/timeout.js";
import { EOAWallets } from "./types.js";
import { WalletIcon } from "./icons/wallet-icon.js";
export const walletTypeConfig = [
    { name: "Coinbase Wallet", key: EOAWallets.COINBASE_WALLET },
    { name: "MetaMask", key: EOAWallets.METAMASK },
    { name: "Wallet Connect", key: EOAWallets.WALLET_CONNECT },
];
export const ConnectionError = ({ connectionType, walletType, handleTryAgain, handleUseAnotherMethod, }) => {
    const getHeadingText = useMemo(() => {
        const walletName = walletType && walletTypeConfig.find((w) => w.key === walletType)?.name;
        switch (connectionType) {
            case "passkey":
                return ls.error.connection.passkeyTitle;
            case "wallet":
                return (walletType &&
                    ls.error.connection.walletTitle + (walletName ?? "wallet"));
            case "timeout":
                return ls.error.connection.timedOutTitle;
        }
    }, [connectionType, walletType]);
    const getBodyText = useMemo(() => {
        switch (connectionType) {
            case "passkey":
                return ls.error.connection.passkeyBody;
            case "wallet":
                return ls.error.connection.walletBody;
            case "timeout":
                return ls.error.connection.timedOutBody;
        }
    }, [connectionType]);
    const getFailedIcon = useMemo(() => {
        switch (connectionType) {
            case "passkey":
                return _jsx(PasskeyConnectionFailed, {});
            case "wallet":
                return walletType && _jsx(WalletIcon, { walletType: walletType });
            case "timeout":
                return _jsx(Timeout, {});
        }
    }, [connectionType, walletType]);
    return (_jsxs("div", { className: "flex flex-col justify-center content-center gap-3", children: [_jsx("div", { className: "flex justify-center", children: _jsx("div", { className: "w-[140px] h-[140px]", children: getFailedIcon }) }), _jsx("h2", { className: "font-semibold text-lg text-center", children: getHeadingText }), _jsx("p", { className: "text-sm text-center text-fg-secondary", children: getBodyText }), _jsx(Button, { className: "mt-3", onClick: handleTryAgain, children: ls.error.cta.tryAgain }), _jsx(Button, { onClick: handleUseAnotherMethod, variant: "social", className: "border-0 hover:shadow-none", children: ls.error.cta.useAnotherMethod })] }));
};
//# sourceMappingURL=connection-error.js.map